<template>
  <div class="device-list">
    <div class="device-item">
      <v-icon-btn
        variant="elevated"
        :data-wml-speech-command="micOn ? t('preCall.commands.mute') : t('preCall.commands.unmute')"
        @click="toggleMic"
        v-model:active="micOn"
        active-icon="msf:mic"
        icon="msf:mic_off"
        active-color="primary"
        size="large"
        :disabled="!isMicSupported"
      />
      <v-icon
        v-if="!mobile"
        color="default"
        :disabled="microphoneAccess === 'denied'"
        :icon="openedPanel === 'microphone' ? 'msf:keyboard_arrow_up' : 'msf:keyboard_arrow_down'"
        @click="togglePanel('microphone')"
      />
    </div>
    <template v-if="initialState.isCameraRecommended">
      <div class="divider"></div>
      <div class="device-item">
        <v-icon-btn
          variant="elevated"
          :data-wml-speech-command="camOn ? t('preCall.commands.cameraOff') : t('preCall.commands.cameraOn')"
          @click="toggleCam"
          active-icon="msf:videocam"
          v-model:active="camOn"
          icon="msf:videocam_off"
          active-color="primary"
          size="large"
          :disabled="!isCamSupported"
        />
      </div>
    </template>
    <div class="divider"></div>
    <div class="device-item">
      <v-icon-btn
        variant="elevated"
        @click="toggleSpeaker"
        active-icon="msf:volume_up"
        :active="!isSpeakerMuted"
        icon="msf:volume_off"
        active-color="primary"
        size="large"
      />
      <v-icon
        v-if="!mobile"
        color="default"
        :disabled="microphoneAccess === 'denied'"
        :icon="openedPanel === 'speaker' ? 'msf:keyboard_arrow_up' : 'msf:keyboard_arrow_down'"
        @click="togglePanel('speaker')"
      />
    </div>
    <template v-if="mobile">
      <div class="divider"></div>
      <div class="device-item">
        <v-icon-btn
          variant="flat"
          icon="msf:tune"
          :active="openedPanel === 'settings'"
          @click="togglePanel('settings')"
          size="large"
        />
      </div>
    </template>
  </div>
</template>
<script setup>
import {useSpeaker} from '@/composables'
import {usePreCall} from '@/stores/preCall'
import {storeToRefs} from 'pinia'
import {useStreamStore} from '@/stores/streamStore'
import {useTranslation} from 'i18next-vue'
import {useDisplay} from 'vuetify'
import {computed} from 'vue'
const initialState = window.__INITIAL_STATE__.app
const {platform, xs} = useDisplay()
const mobile = computed(() => (platform.value.android && platform.value.ios) || xs.value)
const streamStore = useStreamStore()
const {micEnabled, camEnabled, micOn, camOn, microphoneAccess, cameraAccess, isMicSupported, isCamSupported} =
  storeToRefs(streamStore)
const preCall = usePreCall()
const {openedPanel, permissionsModalDevice} = storeToRefs(preCall)
const {isMuted: isSpeakerMuted, toggleMute: toggleSpeaker} = useSpeaker()
const {t} = useTranslation()
const togglePanel = panel => {
  if (openedPanel.value === panel) {
    openedPanel.value = null
  } else {
    openedPanel.value = panel
  }
}
const toggleMic = () => {
  if (microphoneAccess.value !== 'denied') {
    micEnabled.value = !micEnabled.value
  } else {
    permissionsModalDevice.value = 'microphone'
  }
}
const toggleCam = () => {
  if (cameraAccess.value !== 'denied') {
    camEnabled.value = !camEnabled.value
  } else {
    permissionsModalDevice.value = 'camera'
  }
}
</script>
<style lang="scss" scoped>
.device-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-left: 16px;
  padding-right: 16px;
  .divider {
    flex: 1;
    min-width: 0.5em;
    max-width: 30px;
  }
  .device-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
